import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3f5ad260"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "title-wrapper"
};
const _hoisted_2 = {
  class: "font-h3 title"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "underline"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]), _hoisted_3]);
}